function csvConverter(rows) {
  return (
    "data:text/csv;charset=utf-8," + rows.map((e) => e.join(",")).join("\n")
  );
}

export default csvConverter;
